module.exports = __webpack_public_path__ + "img/20191203165656607.6ef11575.jpg";